export const goBackFunction = (newUrl,history) =>{
    if(history.location.state){
    history.push({
      pathname: history.location.state.redirectUrl,
      state: { currentPage: history.location.state.currentPage }
    })}else history.push(newUrl)
}
export const devOpsHoursToTime = (time) => {
  //this function will take time as float e.g. 1.75
  //and will convert that time to hh:mm format e.g. 02:15
  let hour = Math.floor(time);
  let decPart = time - hour;
  const min = 1 / 60;
  decPart = min * Math.round(decPart / min);
  let minute = Math.floor(decPart * 60) + "";
  if (minute.length < 2) {
    minute = "0" + minute;
  }
  hour = hour + "";
  if (hour.length < 2) {
    hour = "0" + hour;
  }
  return hour + ":" + minute;
}